import { asciiTextValidation } from 'framework/form';
import { RISK_STATUS } from 'domain/shared/newProject';

export const risksValidation = {
  id: {
    type: 'string',
    required: false,
  },
  alias: {
    type: 'string',
    required: false,
  },
  title: {
    type: 'string',
    required: true,
    maxSize: 1000,
    ...asciiTextValidation,
  },
  type: {
    type: 'string',
    required: true,
  },
  probability: {
    type: 'string',
    required: true,
  },
  severity: {
    type: 'string',
    required: true,
  },
  riskOwner: {
    type: 'string',
    required: true,
  },
  mitigationStrategy: {
    type: 'string',
    required: false,
  },
  isIncludedInCustomerReport: {
    type: 'string',
    required: false,
  },
  status: {
    type: 'string',
    required: false,
  },
  resolvedAt: {
    type: 'date',
    required: {
      value: true,
      when: {
        $status: { eq: RISK_STATUS.INACTIVE },
      },
    },
  },
  resolveComment: {
    type: 'string',
    required: {
      value: true,
      when: {
        $status: { eq: RISK_STATUS.INACTIVE },
      },
    },
  },
};

export const resolveRiskValidation = {
  resolvedAt: {
    type: 'date',
    required: true,
  },
  resolveComment: {
    type: 'string',
    required: true,
  },
};
